/*
 *
 * TenantFormDialog15783
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';
import { REQUESTS } from 'domain/Data/constants';
import { TENANT_REQUESTS_FORM, TENANT_REQUESTS_FORM_DIALOG, TENANT_REQUESTS_TABLE_GRID } from 'pages/Requests/TenantView/constants';


export class TenantFormDialog15783 extends React.Component {

  render() {
    const { form, detailContainer } = this.props;
    return (
      <AdvancedFormDialog
        name={TENANT_REQUESTS_FORM_DIALOG}
        formName={TENANT_REQUESTS_FORM}
        dataTableName={TENANT_REQUESTS_TABLE_GRID}
        advancedForm={form}
        addModeTitle="Новая заявка"
        editModeTitle="Изменение заявки"
        viewModeTitle="Просмотр заявки"
        copyModeTitle="Копирование заявки"
        addModeSaveButtonLabel="Сохранить и Отправить"
        copyModeSaveButtonLabel="Сохранить и Отправить"
        detailContainer={detailContainer}
        entityName={REQUESTS}
      />
    );
  }
}


TenantFormDialog15783.propTypes = {
  form: PropTypes.node.isRequired,
  mode: PropTypes.string,
};

export default TenantFormDialog15783;
